import { ISize } from "../../../../base/domain/drawing";
import { IPropertyPresentable, instanceOfIPropertyPresentable } from "../../../../base/domain/system/edit";

export interface ISizePropertyPresentable {
  size(): IPropertyPresentable<ISize>;
}

export function instanceOfISizePropertyPresentable(instance: any): instance is ISizePropertyPresentable {
  return instance
      && instance.size
      && instanceOfIPropertyPresentable<ISize>(instance.size());
}
